<template>
  <div class="app-shell">
    <AppNavbar />
    <main class="app-main">
      <router-view />
    </main>
    <AppFooter />
  </div>
</template>

<script setup>
import AppNavbar from '@/components/AppNavbar.vue'
import AppFooter from '@/components/AppFooter.vue'
</script>

<style>
:global(html, body, #app) {
  height: 100%;
}

.app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-main {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  padding-top: 12px; /* offset fixed navbar */
}

a:hover {
  text-decoration: none!important;
}
</style>
